<template>
    <div class="author-title-con flexible jc-between aItem-center">
        <div class="breadbox">
            <el-breadcrumb separator="/">
                <!-- <div class="clearfix bread f18">
                    <el-breadcrumb-item
                            v-for="item in breadlist"
                            :key="item.path"
                            class="flexible aItem-center"
                            :to="{ path: item.path }"
                    >
                        <div class="flexible aItem-center text-333">
                            <img v-if="item.meta.icon" class="book-title-icon" :src="item.meta.icon"/>
                            <span>{{ item.name }}</span>
                        </div>
                    </el-breadcrumb-item
                    >
                </div> -->
            </el-breadcrumb>
        </div>
        <slot name="new-stroy"></slot>
    </div>
</template>

<script>
    export default {
        name: "",
        data () {
            return{
                breadlist: [],
            }
        },
        watch: {
            $route() {
                /* 面包屑 */
                this.getBreadcrumb();
            }
        },
        created() {
            this.getBreadcrumb()
        },
        methods: {
            // 面包屑
            getBreadcrumb() {
                let matched = this.$route.matched.filter(item => item.name);
                this.breadlist = matched;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .author-title-con{
        .bread{
            padding-left: 0;
        }
        .book-title-icon{
            width: 30px;
            height: 30px;
            margin-right: 5px;
            position: static;
        }
        /deep/.el-breadcrumb__separator{
            margin: 0 2px;
            color: #999;
            font-weight: normal;
            font-size: 20px;
        }
    }
</style>
